import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import messages from "components/messagesDescription";
import PdfIcon from "../../../assets/images/svg/pdf_icon.svg";
import UpArrow from "../../common/ArrowUp";
import DownArrow from "../../common/ArrowDown";
import PlanBox from "./PlanBoxPP";
import PlanBoxMini from "./PlanBoxMini";
import withMatchMediaProps from "@hocs/with-match-media-props";
import { isPlanMemberGrouped, isPlanRequireUW } from "./EnrollmentDataUtil";
import PlanMembers from "./PlanMembers";
import { showPopup } from "actions/popupActions";
import { renderAsHTML } from "../../../utils";
import { togglePanel, toggleShowMore } from "../../../actions/enrollmentActions";
import UwIcon from "../../../assets/images/svg/uw_icon.svg";
import InformationIcon from "../../../assets/images/svg/information_icon.svg";
import { FormattedHTMLMessage } from "react-intl";

const BenefitPanelPP = ({ benefit, isNarrowScreen, intl }) => {
  const dispatch = useDispatch();
  const currency = useSelector(state => state.enrollment.details.enrolmentCurrency);
  const plans = benefit.benefitOptions.options || [];
  const selectedPlan = plans.find(x => x.isSelected);
  const lastEnrolledPlan = benefit.lastApproved && benefit.lastApproved.name;

  const toggleShowMoreDetail = e => {
    e.preventDefault();
    dispatch(toggleShowMore(benefit.benefitID));
  };

  const toggleBenefitPanel = e => {
    e.preventDefault();
    dispatch(togglePanel(benefit.benefitID));
  };

  const popupShowMore = evt => {
    evt.preventDefault();
    const { currentTarget } = evt;
    const href = currentTarget.getAttribute("href");
    dispatch(
      showPopup({
        element: renderAsHTML(
          "div",
          intl.formatMessage({
            id: benefit.benefitDescription,
            defaultMessage: benefit.benefitDescription,
          })
        ),
        callback: null,
        showClose: true,
      })
    );
  };

  const PanelHead = () => (
    <Fragment>
      <div className="panel-head">
        <button
          className="link"
          onClick={toggleBenefitPanel}
          style={{ color: "black", justifyContent: "flex-start",textAlign: "left" }}
        >
          <strong>
            {intl.formatMessage({
              id: benefit.benefitName,
              defaultMessage: benefit.benefitName,
            })}
          </strong>
          <span style={{ marginLeft: "5px" }}>
            {benefit.isExpanded ? (
              <UpArrow width="14px" height="14px" />
            ) : (
              <DownArrow width="16px" height="16px" />
            )}
          </span>
        </button>
        {benefit.isExpanded && (
          <div className="benefit-panel-head">
            {benefit.benefitDescription && (
              <button
                className="link"
                onClick={isNarrowScreen ? popupShowMore : toggleShowMoreDetail}
              >
                <span>{intl.formatMessage(messages.learnMoreDescription)}</span>
                <span style={{ marginLeft: "5px" }}>
                  {benefit.isShownMore ? (
                    <UpArrow width="14px" height="14px" />
                  ) : (
                    <DownArrow width="16px" height="16px" />
                  )}
                </span>
              </button>
            )}
            {Array.isArray(benefit.productSummary) &&
              benefit.productSummary.map(ps => {
                return (
                  ps.url && (
                    <a href={ps.url} rel="noreferrer" target="_blank" style={{ marginLeft: "5px" }}>
                      <PdfIcon />
                      <span>{intl.formatMessage(messages.enrollment.viewPlanDescription)}</span>
                    </a>
                  )
                );
              })}
          </div>
        )}
      </div>
      <div
        dangerouslySetInnerHTML={{
          __html: intl.formatMessage({
            id: benefit.briefDescription,
            defaultMessage: benefit.briefDescription,
          }),
        }}
      />
      {benefit.isShownMore && (
        <div>
          {intl.formatMessage({
            id: benefit.benefitDescription,
            defaultMessage: benefit.benefitDescription,
          })}
        </div>
      )}
      <div>
        {intl.formatMessage(messages.enrollment.priceDescription)} <strong>{currency}</strong>
      </div>
      {lastEnrolledPlan && (
        <div>
          {intl.formatMessage(messages.enrollment.lastEnrolledSumAssuredPlan)}{" "}
          <strong>{lastEnrolledPlan}</strong>
        </div>
      )}
    </Fragment>
  );

  return benefit.selectable == "true" ? (
    <div className="card" style={isNarrowScreen ? { padding: 0 } : {}}>
      <div style={{ padding: "10px" }}>
        <PanelHead />
      </div>
      {isPlanMemberGrouped(selectedPlan) && (
        <strong>{intl.formatMessage(messages.enrollment.selectPlanDescription)}</strong>
      )}
      {benefit.isExpanded ? (
        <div className="grid__wrapper plan-container">
          {plans.map(plan => (
            <PlanBox key={plan.id} benefit={benefit} plan={plan} intl={intl} />
          ))}
        </div>
      ) : (
        <div className="grid__wrapper plan-container">
          {plans
            .filter(plan => plan.isSelected)
            .map(plan => (
              <PlanBoxMini key={plan.id} benefit={benefit} plan={plan} intl={intl} />
            ))}
        </div>
      )}
      {benefit.isExpanded && selectedPlan && <PlanMembers benefit={benefit} plan={selectedPlan} intl={intl} />}
      {isNarrowScreen && <MobileHDFNote plan={selectedPlan} />}
    </div>
  ) : (
    ""
  );
};

const MobileHDFNote = ({ plan }) => {
  const isHDFRequired = isPlanRequireUW(plan);
  return (
    <span className="mobile-plan__Note">
      {isHDFRequired && (
        <Fragment>
          <span className="mobile-plan__HdfIcon">
            <UwIcon />
          </span>
          <span className="mobile-plan__HDFDescription">
            <FormattedHTMLMessage {...messages.HDFRDescription} />
          </span>
          <span className="mobile-plan__InfoIcon">
            <InformationIcon />
          </span>
        </Fragment>
      )}
    </span>
  );
};

BenefitPanelPP.propTypes = {
  benefit: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool,
  intl: PropTypes.func,
};

MobileHDFNote.propTypes = {
  plan: PropTypes.object.isRequired,
};

export default withMatchMediaProps({
  isNarrowScreen: {
    maxWidth: 680,
  },
})(BenefitPanelPP);



// WEBPACK FOOTER //
// ./components/employee/shop/BenefitPanelPP.js